<template>
  <div>
    <Modal
      :mask="false"
      v-model="modal"
      width="50"
      :title="modalTitle"
      footer-hide>
      <Table :class="{trees:modalTitle==='片区响应'}" max-height="320"
             :row-key="modalTitle==='片区响应'?'indexCode':'id'"
             :span-method="handleSpan"
             :data="resourcesTableData" :loading="tableLoading" :columns="resourcesTableColumns">
        <template slot-scope="{ row, index }" slot="action">
          <el-button type="text" size="small" style="margin-right: 5px" @click="show(row)">查看</el-button>
        </template>
      </Table>
      <Page
        v-if="this.modalTitle==='应急演练'"
        :total="resourcesTableTotal"
        :current="currentPage"
        @on-change="pageChange"
        :page-size="pageSize"
        show-total
        style="position: absolute;bottom: 10px;left: 50%;transform: translateX(-50%)"></Page>
    </Modal>
    <PrimaryBox :flag="true">
      <template slot="title">应急资源</template>
      <div class="resourcesContent">
        <!--        <div class="resourcesTop">-->
        <!--          <div class="resourcesItem" :style="{backgroundImage: `url(${bgList[index]})`}"-->
        <!--               v-for="(item,index) in resourcesList" :key="index" @click="showModal(item)">-->
        <!--            <p class="title">{{ item.title }}</p>-->
        <!--            <p class="value">{{ item.value }}</p>-->
        <!--          </div>-->
        <!--        </div>-->
        <!--        <div style="width: 98%;height: 1px;background-color: #809AA8;margin: 5px auto"></div>-->
        <div class="resourcesBottom">
          <div class="resourcesProportion items" @click="showModal({title:'应急库'})">
            <Warehouse></Warehouse>
          </div>
          <div class="resourcesProportion items" @click="showModal({title:'应急队伍'})">
            <Team></Team>
          </div>
          <div class="resourcesProportion items" @click="showModal({title:'应急专家'})">
            <Specialist></Specialist>
          </div>
        </div>
        <div class="resourcesBottom">
          <div class="resourcesProportion items" @click="showModal({title:'应急预案'})">
            <Plan></Plan>
          </div>
          <!--          <div class="resourcesProportion items" @click="showModal({title:'片区响应'})">-->
          <!--            <Area></Area>-->
          <!--          </div>-->
          <div class="resourcesProportion items" @click="showModal({title:'值班备勤'})">
            <Duty></Duty>
          </div>
          <div class="resourcesProportion items" @click="showModal({title:'应急演练'})">
            <Drill></Drill>
          </div>
        </div>
      </div>
    </PrimaryBox>
    <Modal v-model="materials" title="物资" footer-hide :width="60">
      <Table :loading="materialsLoading" :height="300" :data="materialsList" :columns="materialsColumns"></Table>
    </Modal>
  </div>
</template>

<script>
import PrimaryBox from "@/views/Screen/components/PrimaryBox/PrimaryBox";
import Warehouse from "@/views/Screen/components/Resources/components/warehouse/warehouse";
import Specialist from "@/views/Screen/components/Resources/components/specialist/specialist";
import Team from "@/views/Screen/components/Resources/components/team/team";
import Plan from "@/views/Screen/components/Resources/components/Plan/Plan.vue";
import Area from "@/views/Screen/components/Resources/components/Area/Area.vue";
import {preplan, teams, expert, warehouse, areaList, drillList, DutyList, materialsColumns} from './js/columns'
import Drill from "@/views/Screen/components/Resources/components/Drill/Drill.vue";
import Duty from "@/views/Screen/components/Resources/components/Duty/Duty.vue";

export default {
  components: {
    PrimaryBox,
    Warehouse,
    Specialist,
    Team,
    Plan,
    Duty,
    Drill,
  },
  name: "Resources",
  data() {
    return {
      materials: false,
      materialsLoading: false,
      modal: false,
      resourcesTableTotal: 0,
      modalTitle: '',
      resourcesTableData: [],
      resourcesTableColumns: [],
      bgList: [require('./../../images/resourcesbg1.png'), require('./../../images/resourcesbg2.png'), require('./../../images/resourcesbg3.png'), require('./../../images/resourcesbg4.png'), require('../../images/resourcesbg5.png')],
      resourcesList: [],
      countStorehouseByType: {},
      tableLoading: false,
      currentPage: 1,
      pageSize: 5,
      materialsList: [],
      materialsColumns,
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    show(row) {
      this.materials = true
      this.materialsLoading = true
      let id = row.storeHouse.id
      console.log(row)
      this.$http.get(`api/goods/getGoods/${id}`).then(res => {
        this.materialsList = res.data.data
        this.materialsLoading = false
      })
    },
    handleSpan({row, column, rowIndex, columnIndex}) {
      //合并第二列,这里columnIndex===1 根据具体业务来，比如本示例中需要合并的name为第二列
      if (columnIndex === 0) {
        //计算合并的行数列数
        let x = row.mergeCol === 0 ? 0 : row.mergeCol;
        let y = row.mergeCol === 0 ? 0 : 1;
        return [x, y];
      }
    },
    formatData(data) {
      let names = [];
      //筛选出不重复的 name值,将其放到 names数组中
      data.forEach((e) => {
        if (!names.includes(e.dutyDate)) {
          names.push(e.dutyDate);
        }
      });

      let nameNums = [];
      //将names数组中的 name值设置默认合并0个单元格,放到 nameNums中
      names.forEach((e) => {
        nameNums.push({dutyDate: e, num: 0});
      });

      //计算每种 name值所在行需要合并的单元格数
      data.forEach((e) => {
        nameNums.forEach((n) => {
          if (e.dutyDate === n.dutyDate) {
            n.num++;
          }
        });
      });

      //将计算后的合并单元格数整合到 data中
      data.forEach((e) => {
        nameNums.forEach((n) => {
          if (e.dutyDate === n.dutyDate) {
            if (names.includes(e.dutyDate)) {
              e.mergeCol = n.num;
              //删除已经设置过的值(防止被合并的单元格进到这个 if 语句中)
              names.splice(names.indexOf(n.dutyDate), 1);
            } else {
              //被合并的单元格设置为 0
              e.mergeCol = 0;
            }
          }
        });
      });
      //将整理后的数据交给表格渲染
      return data;
    },
    pageChange(val) {
      this.currentPage = val
      this.getData()
    },
    getData() {
      this.$http.get(`/api/storehouse/getEmergencySourceNumber`).then(res => {
        if (res.status === 200) {
          this.resourcesList = res.data
        }
      })
    },
    showModal(item) {
      this.resourcesTableData = []
      this.modal = true
      this.resourcesTableTotal = 0
      if (item.title === '应急预案') {
        this.modalTitle = '应急预案'
        this.resourcesTableColumns = preplan
        this.getEmergencySourceList()
      } else if (item.title === '应急队伍') {
        this.resourcesTableColumns = teams
        this.modalTitle = '应急队伍'
        this.getEmergencyTeamList()
      } else if (item.title === '应急专家') {
        this.modalTitle = '应急专家'
        this.resourcesTableColumns = expert
        this.getEmergencyExpertList()
      } else if (item.title === '应急库') {
        this.modalTitle = '应急库'
        this.resourcesTableColumns = warehouse
        this.getEmergencyWarehouseList()
      } else if (item.title === '片区响应') {
        this.modalTitle = '片区响应'
        this.resourcesTableColumns = areaList
        this.getAreaList()
      } else if (item.title === '应急演练') {
        this.modalTitle = '应急演练'
        this.resourcesTableColumns = drillList
        this.getDrillData()
      } else if (item.title === '值班备勤') {
        this.modalTitle = '值班备勤'
        this.resourcesTableColumns = DutyList
        this.getDutyData()
      }
    },
    // 获取值班备勤数据
    getDutyData() {
      this.tableLoading = true
      let request = {}
      // console.log(request)
      this.$http.post(`/api/getScreenDutyCalendarList`, {}).then(res => {
        if (res.status === 200) {
          this.tableLoading = false
          this.resourcesTableData = this.formatData(res.data)
          this.modal = true
        } else {
          this.tableLoading = false
          this.$Message.error('获取失败')
        }
        this.tableLoading = false
      })
    },
    // 获取演练数据
    getDrillData() {
      this.tableLoading = true
      let request = {}
      // console.log(request)
      this.$http.post(`/api/getScreenEmergencyDrillsList?page=${this.currentPage}&size=${this.pageSize}`, request).then(res => {
        if (res.status === 200) {
          this.tableLoading = false
          this.resourcesTableData = res.data.data
          this.resourcesTableTotal = res.data.recordsTotal
          this.modal = true
        } else {
          this.tableLoading = false
          this.$Message.error('获取失败')
        }
        this.tableLoading = false
      })
    },
    // 获取应急资源列表
    getEmergencySourceList() {
      this.tableLoading = true
      this.$http.post(`/api/getPlanList`, {}).then(res => {
        if (res.status === 200) {
          this.tableLoading = false
          this.resourcesTableData = res.data.data
          this.resourcesTableTotal = res.data.recordsTotal
        } else {
          this.tableLoading = false
          this.$Message.error('获取应急预案列表失败')
        }
      })
    },
    // 获取应急队伍列表
    getEmergencyTeamList() {
      this.tableLoading = true
      this.$http.post(`/api/getEmergencyRanksCaptainsList`, {}).then(res => {
        if (res.status === 200) {
          this.tableLoading = false
          this.resourcesTableData = res.data.data
          this.resourcesTableTotal = res.data.recordsTotal
        } else {
          this.tableLoading = false
          this.$Message.error('获取应急队伍列表失败')
        }
      })
    },
    // 获取应急专家列表
    getEmergencyExpertList() {
      this.tableLoading = true
      this.$http.post(`/api/specialist/getAll`, {}).then(res => {
        if (res.status === 200) {
          this.tableLoading = false
          this.resourcesTableData = res.data.data.list
          this.resourcesTableTotal = res.data.data.total
        } else {
          this.tableLoading = false
          this.$Message.error('获取应急专家列表失败')
        }
      })
    },
    // 获取应急仓库列表
    getEmergencyWarehouseList() {
      this.tableLoading = true
      this.$http.post(`/api/storehouse/getAll`, {}).then(res => {
        if (res.status === 200) {
          this.tableLoading = false
          this.resourcesTableData = res.data.data.list
          this.resourcesTableTotal = res.data.data.total
        } else {
          this.tableLoading = false
          this.$Message.error('获取应急库列表失败')
        }
      })
    },
    // 获取片区相应列表
    getAreaList() {
      this.tableLoading = true
      this.$http.get(`/api/getRegionalResponse`).then(res => {
        if (res.status === 200) {
          console.log(res)
          this.tableLoading = false
          this.resourcesTableData = this.tree(res.data)
        } else {
          this.tableLoading = false
          this.$Message.error('获取片区相应列表失败')
        }
      })
    },
    // 平面数据转树形数据，根据indexCode和parentIndexCode，indexCode为当前节点的id，parentIndexCode为当前节点的父节点id，根节点的父节点id为root000000，递归
    tree(list) {
      const treeList = []
      const map = {}
      // 遍历list数组，加入一个对象里面，id作为key.数组的item作为value
      list.forEach((item) => {
        map[item.indexCode] = item
        item.children = []
      })
      // 再次遍历list数组，如果map对象id与pid匹配成功，添加至item.children里面，反之，添加到treeList里面
      list.forEach((item) => {
        if (map[item.parentIndexCode]) {
          map[item.parentIndexCode].children.push(item)
        } else {
          treeList.push(item)
        }
      })
      return treeList
    }
  }
}
</script>

<style scoped lang="less">
@import "Resources.less";

:deep(.ivu-page-item) {
  background-color: transparent;
  border: 1px solid #2E6B9E;
}

:deep(.ivu-page-next) {
  background-color: transparent;
  border: 1px solid #2E6B9E;
}

:deep(.ivu-page-prev) {
  background-color: transparent;
  border: 1px solid #2E6B9E;
}

:deep(.ivu-page-item-active) {
  background-color: #2E6B9E;
  border: 1px solid #2E6B9E;
}
</style>
